import { Pipe, PipeTransform } from "@angular/core";
import { IIMetadataItemOptionsDto } from "app/main/pages/settings/documentfields/metadata-item.dto";

@Pipe({ name: "showDropListLabel" })


export class ShowDropListLabelPipe implements PipeTransform {
    
    transform(fieldOptions: IIMetadataItemOptionsDto[], value: string): string {
        return fieldOptions?.find(option => option.value === value)?.name || '';
    }
}